import { useCallback, useMemo } from 'react';
import { SVMChain } from '../../types';
import { buyEvmNFTs, delistEvmNFTs, listEvmNFTs, mintEvmNFTs, updateEvmNFTPrices, withdrawEvmProceeds, } from '../evm/evm-actions';
import { buySvmNFTs, delistSvmNFTs, listSvmNFTs, mintSvmNFTs, updateSvmNFTPrices, } from '../svm/svm-actions';
export function useOnChainActions({ activeChain, activeState, evmSigner, toast, addTransaction, txIdToLink, createNftUris, }) {
    const evmDeps = useMemo(() => ({
        activeChain,
        activeState,
        evmSigner,
        toast,
        addTransaction,
        txIdToLink,
    }), [activeChain, activeState, evmSigner, toast, addTransaction, txIdToLink]);
    const svmDeps = useMemo(() => ({
        activeChain,
        addTransaction,
        txIdToLink,
    }), [activeChain, addTransaction, txIdToLink]);
    const mintNFTs = useCallback(async (nfts) => {
        if (activeState.isStable == false) {
            throw Error('Network is not stable yet, please try again later.');
        }
        toast.info('Uploading NFT Images to Arweave!!!');
        if (!createNftUris) {
            throw Error('NFT URI upload is not configured for this app.');
        }
        const { data: uris } = await createNftUris(nfts, activeChain);
        toast.info('Minting to my wallet!!!');
        if (activeChain === SVMChain.Solana) {
            return mintSvmNFTs(svmDeps, uris, nfts);
        }
        return mintEvmNFTs(evmDeps, nfts, uris);
    }, [activeChain, activeState.isStable, createNftUris, evmDeps, svmDeps, toast]);
    const buyNFTs = useCallback(async (nfts) => {
        if (activeChain === SVMChain.Solana) {
            return buySvmNFTs(svmDeps, nfts);
        }
        return buyEvmNFTs(evmDeps, nfts);
    }, [activeChain, evmDeps, svmDeps]);
    const withdrawMyProceeds = useCallback(async () => {
        if (activeChain === SVMChain.Solana) {
            throw Error('Avaiable for only Ethereum');
        }
        return withdrawEvmProceeds(evmDeps);
    }, [activeChain, evmDeps]);
    const listNFTs = useCallback(async (nfts) => {
        if (activeChain === SVMChain.Solana) {
            return listSvmNFTs(svmDeps, nfts);
        }
        return listEvmNFTs(evmDeps, nfts);
    }, [activeChain, evmDeps, svmDeps]);
    const delistNFTs = useCallback(async (nfts) => {
        if (activeChain === SVMChain.Solana) {
            return delistSvmNFTs(svmDeps, nfts);
        }
        return delistEvmNFTs(evmDeps, nfts);
    }, [activeChain, evmDeps, svmDeps]);
    const updateNFTPrices = useCallback(async (nfts) => {
        if (activeChain === SVMChain.Solana) {
            return updateSvmNFTPrices(svmDeps, nfts);
        }
        return updateEvmNFTPrices(evmDeps, nfts);
    }, [activeChain, evmDeps, svmDeps]);
    return {
        mintNFTs,
        buyNFTs,
        listNFTs,
        delistNFTs,
        updateNFTPrices,
        withdrawMyProceeds,
    };
}
